import { requestApi } from '../util/network'
import axios from 'axios'  // 添加这行导入语句

export const qygoodlist = async () => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            url: env.API_HOST + "/Jzuniqy/qyorder_goodlist"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qychktk = async (token) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: {token:token},
            url: env.API_HOST + "/Jzuniqy/qyorder_chktoken"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qybuy1 = async (token) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: {token:token},
            url: env.API_HOST + "/Jzuniqy/qyorder_buy1"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qybuy2 = async (token,member_id,goodid,reciver_name,phone,address) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: {token:token,member_id:member_id,goodid:goodid,goods_num:1,reciver_name:reciver_name,phone:phone,address:address},
            url: env.API_HOST + "/Jzuniqy/qyorder_buy2"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qybuypay = async (pay_sn,member_id) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: {pay_sn:pay_sn,member_id:member_id},
            url: env.API_HOST + "/Jzuniqy/qyorder_pay"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qypayretrun = async (order_sn,pay_sn) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: {order_sn:order_sn,pay_sn:pay_sn},
            url: env.API_HOST + "/Jzuniqy/qyorder_info"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qypayresult= async (order_sn,pay_sn) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: {order_sn:order_sn,pay_sn:pay_sn},
            url: env.API_HOST + "/Jzuniqy/qyorder_paysel"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qybuycancel= async (order_sn,pay_sn,member_id) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: {order_sn:order_sn,pay_sn:pay_sn,member_id:member_id},
            url: env.API_HOST + "/Jzuniqy/qyorder_paycancel"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qypayinfo= async (orderId) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: {orderId:orderId},
            url: env.API_HOST + "/Jzuniqy/qyorder_payinfo"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qyorderdetail= async (orderId) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: {orderId:orderId},
            url: env.API_HOST + "/Jzuniqy/qyorder_detail"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qyorderrefund= async (order_id,member_id) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: {order_id:order_id,member_id:member_id},
            url: env.API_HOST + "/Jzuniqy/qyorder_allrefund"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qyorderexpress= async (shipping_code,express_name,order_sn) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: {shipping_code:shipping_code,express_name:express_name,order_sn:order_sn},
            url: env.API_HOST + "/Jzuniqy/qyorder_Express"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qyordershouhuo= async (order_id,member_id,member_name) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: {order_id:order_id,member_id:member_id,member_name:member_name},
            url: env.API_HOST + "/Jzuniqy/qyorder_receive"
        });
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};

